import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { memo } from 'react';
const LegendKey = ({ image, style, name, }) => (_jsx("div", { className: "grow-0 shrink basis-[21%] pr-2", children: _jsxs("div", { className: "flex flex-nowrap justify-start items-center gap-x-2", children: [image
                ? (_jsx("img", { className: "w-3.5 h-3.5", src: image, alt: name })) : (_jsx("div", { className: "w-2 h-2 rounded-full", style: style })), _jsx("span", { className: "text-[10px] text-gray-700 capitalize whitespace-nowrap", children: name })] }) }));
LegendKey.propTypes = {
    image: PropTypes.string,
    style: PropTypes.object,
    name: PropTypes.string,
};
// TODO: Is there any profit of memoizing such a simple component?
export default memo(LegendKey);
